import React from 'react';
import Layout from '../layouts/claire';
import { Link } from 'react-router';
import config from '../../config';
import Menu from '../partials/menu';
import TopRightMenu from '../partials/top_right_menu';
import CustomDatePicker from '../partials/custom_date_picker';
import fakeAuth from '../../fakeAuth';
import LineLoader from '../partials/line_loader';
import DatePicker from 'react-datepicker';
import { Animated } from 'react-animated-css';
import moment from 'moment';
import _ from 'lodash';
import { padWithZeros, piece_block_info, sortFloors } from '../../helpers';

require("moment/min/locales.min");

/*
    Prioridad al pintar una celda cuando una habitacion tiene mas de una reserva
    viva en la misma noche (ej: una que hizo check-out y otra que entra).
    Anulado (6) no ocupa habitacion, por eso no esta en la lista.
*/
const STATUS_PRIORITY = [3, 2, 1, 5, 4];

const NO_DISPONIBLE = _.find(config.room_status, s => s.id === 12);

class Rack extends React.Component {

    state = {
        menu_toggled: false,
        day: moment(moment().format('YYYY-MM-DD'), 'YYYY-MM-DD'),
        floors: [],
        rooms: [],
        bookings: [],
        search: '',
        loading: true,
        hotel_name: localStorage.getItem('lb.ip') ? JSON.parse(localStorage.getItem('lb.ip')).Name : null
    }

    // Lifecycle
    componentWillMount() {
        this.props.logic_actions?.fetch_conversion_rates();
        const { params } = this.props;
        if (!params.id) {
            this.props.router.push('/properties');
            return;
        }
        this.props.properties_actions && this.props.properties_actions.fetch_one(params.id);
        this.props.floors_actions && this.props.floors_actions.fetch(params.id);
        this.props.rooms_actions && this.props.rooms_actions.fetch(params.id);
        this.onFetch();
    }
    componentWillReceiveProps = nextProps => {
        const { floors, rooms, bookings } = nextProps;
        this.setState({
            floors: floors || this.state.floors,
            rooms: rooms || this.state.rooms,
            bookings: bookings || this.state.bookings,
            loading: false
        });
    }
    //

    onFetch = () => {
        const { day } = this.state;
        this.setState({ loading: true });
        this.props.booking_actions && this.props.booking_actions.fetch_range({
            IdProperty: this.props.params.id,
            CheckIn: day.format('YYYY-MM-DD'),
            CheckOut: moment(day).add(1, 'day').format('YYYY-MM-DD')
        });
    }

    onDay = (date) => {
        this.setState({ day: moment(moment(date).format('YYYY-MM-DD'), 'YYYY-MM-DD') }, this.onFetch);
    }

    /*
        Devuelve un mapa IdPiece -> { book, book_room, guest } con la reserva que
        ocupa cada habitacion en la noche seleccionada.
    */
    occupancy = () => {
        const { bookings, day } = this.state, day_str = day.format('YYYY-MM-DD');
        let taken = {};

        (bookings || []).forEach(book => {
            if (book.IsQuote) return;
            if (STATUS_PRIORITY.indexOf(book.IdStatus) === -1) return; // Anulado y otros no ocupan
            (book.Rooms || []).forEach(book_room => {
                if (!book_room.IdPiece) return;

                const check_in = moment(book_room.CheckIn || book.CheckIn).utc().format('YYYY-MM-DD');
                const check_out = moment(book_room.CheckOut || book.CheckOut).utc().format('YYYY-MM-DD');
                // La noche pertenece a la reserva desde el check-in hasta la noche previa al check-out
                if (day_str < check_in || day_str >= check_out) return;

                const guests = _.filter(book.Guests || [], g => g.IdBookRoom === book_room.IdBookRoom);
                const guest = _.find(guests, g => !g.IsCompanion) || _.first(guests);
                const candidate = { book, book_room, guest, check_in, check_out };

                const current = taken[book_room.IdPiece];
                if (!current || STATUS_PRIORITY.indexOf(book.IdStatus) < STATUS_PRIORITY.indexOf(current.book.IdStatus)) {
                    taken[book_room.IdPiece] = candidate;
                }
            });
        });

        return taken;
    }

    /*
        Aplana los pisos con sus habitaciones y les adosa tipo, bloqueo y ocupacion.
        Orden natural por Label: "101", "102", "110" en vez del orden alfanumerico.
    */
    matrix = () => {
        const { floors, rooms, day } = this.state, taken = this.occupancy();

        return sortFloors(floors).map(floor => {
            const cells = [...(floor.Pieces || [])]
                .sort((a, b) => String(a.Label || '').localeCompare(String(b.Label || ''), undefined, { numeric: true, sensitivity: 'base' }))
                .map(piece => {
                    const block = piece_block_info(piece, day);
                    const room = _.find(rooms || [], r => r.IdRoom === piece.IdRoom);
                    return {
                        piece,
                        room_type: room ? room.GivenName : null,
                        blocked: block && block.blocked ? block : null,
                        booking: taken[piece.IdPiece] || null
                    };
                });
            return { floor, cells };
        });
    }

    onCellClick = (cell) => {
        const { id } = this.props.params;
        if (cell.booking) {
            this.props.router.push(`/booking/${cell.booking.book.IdBook}`);
            return;
        }
        if (cell.blocked) {
            this.props.router.push(`/housekeep/${id}`);
            return;
        }
        // Habitacion libre: nueva reserva con la fecha del rack y la habitacion ya elegidas
        this.props.router.push({
            pathname: `/booking/add/${id}`,
            query: {
                checkin: this.state.day.format('YYYY-MM-DD'),
                room: cell.piece.IdRoom,
                piece: cell.piece.IdPiece,
                label: cell.piece.Label
            }
        });
    }

    // Nombre a mostrar del huesped principal de la habitacion
    guest_name = (booking) => {
        if (!booking) return null;
        const { guest, book } = booking;
        if (guest && (guest.FirstName || guest.LastName)) return `${guest.FirstName || ''} ${guest.LastName || ''}`.trim();
        return book.GivenName || 'Sin asignar';
    }

    // null = sin busqueda activa, true = coincide, false = no coincide
    matches_search = (cell) => {
        const term = (this.state.search || '').trim().toLowerCase();
        if (!term) return null;
        const haystack = [
            cell.piece.Label,
            cell.room_type,
            this.guest_name(cell.booking),
            cell.booking ? padWithZeros(cell.booking.book.PNR) : null,
            cell.booking ? cell.booking.book.CoorporateName : null
        ].filter(v => v).join(' ').toLowerCase();
        return haystack.indexOf(term) !== -1;
    }

    renderHeader = () => {
        return <div className="d-flex">
            <div className="w-100 d-flex ">
                <i className="fas fa-th blue font-40 align-self-center" />
                <div className="align-self-center d-flex flex-column">
                    <span className="white ms-3 font-20 line1 poppins">Rack de habitaciones</span>
                    <Link to="/properties" className="white ms-3 font-10 poppins underlined">{this.state.hotel_name}</Link>
                </div>
            </div>
            <div className="w-100 d-flex align-self-center">
                <TopRightMenu {...this.props} />
            </div>
        </div>
    }

    renderTabs = () => {
        const { id } = this.props.params, me = fakeAuth.getUser();
        return <div className="w-100 d-flex mt-4">
            <Link to={`/frontdesk/${id}`} className="btn btn-link d-flex">
                <i className="far fa-calendar gray font-18 align-self-center" />
                <span className="gray ms-3 font-16 poppins align-self-center">Calendario</span>
            </Link>
            <div className="btn btn-link d-flex">
                <i className="fas fa-th blue font-18 align-self-center" />
                <span className="white ms-3 font-16 poppins align-self-center">Rack</span>
            </div>
            {(me.Permissions & (config.permissions.SuperAdmin | config.permissions.Frontdesk | config.permissions.Admin)) !== 0 && <Link to={`/bookings/${id}`} className="btn btn-link d-flex">
                <i className="fas fa-list fa-square-check gray font-18 align-self-center" />
                <span className="gray ms-3 font-16 poppins align-self-center">Listado de reservas</span>
            </Link>}
        </div>
    }

    renderKpis = (rows) => {
        const cells = _.chain(rows).map(r => r.cells).flattenDeep().value();
        const total = cells.length;
        const blocked = _.filter(cells, c => c.blocked && !c.booking).length;
        const busy = _.filter(cells, c => c.booking).length;
        const free = total - busy - blocked;
        const sellable = total - blocked;
        const rate = sellable > 0 ? Math.round((busy / sellable) * 100) : 0;

        const kpi = (label, value, color) => <div className="rack-kpi d-flex flex-column px-3 py-2 ms-2">
            <span className={`${color} font-14 poppins line1`}>{value}</span>
            <span className="gray-light font-8 poppins line1 mt-1">{label}</span>
        </div>;

        return <div className="d-flex flex-wrap justify-content-end">
            {kpi('Ocupadas', busy, 'white')}
            {kpi('Disponibles', free, 'green')}
            {kpi('Fuera de servicio', blocked, 'red')}
            {kpi('Ocupación', `${rate}%`, 'blue')}
        </div>
    }

    renderLegend = () => {
        const item = (label, className, style) => <div className="d-flex align-self-center me-3">
            <span className={`rack-dot align-self-center ${className || ''}`} style={style} />
            <span className="gray-light font-8 poppins align-self-center ms-2">{label}</span>
        </div>;

        return <div className="d-flex flex-wrap align-self-center">
            {config.booking_status.filter(s => s.id !== 6).map(s =>
                <div key={s.id}>{item(s.name, s.color_class.split(' ')[0].replace('w3-', 'bg-'))}</div>
            )}
            {item('Disponible', null, { backgroundColor: '#15191E', border: '1px dashed #343f4b' })}
            {item('Fuera de servicio', 'bg-red')}
        </div>
    }

    renderControls = (rows) => {
        const { day } = this.state, is_today = day.format('YYYY-MM-DD') === moment().format('YYYY-MM-DD');

        return <div className="d-flex flex-wrap">

            {/* NAVEGACION DEL DIA */}
            <div className="d-flex align-self-center">
                <button className="btn bg-gray-dark justify-content-center" title="Día anterior"
                    onClick={() => this.onDay(moment(day).add(-1, 'day'))}>
                    <i className="fas fa-chevron-left white font-12 align-self-center" />
                </button>
                <button className="btn bg-gray-dark ms-1 justify-content-center" title="Día siguiente"
                    onClick={() => this.onDay(moment(day).add(1, 'day'))}>
                    <i className="fas fa-chevron-right white font-12 align-self-center" />
                </button>
                <div className="d-flex flex-column ms-3 align-self-center">
                    <span className="white font-16 poppins line1">{moment(day).locale('es').format('dddd D [de] MMMM YYYY').toLocaleUpperCase()}</span>
                    <span className="gray-light font-8 poppins line1 mt-1">{is_today ? 'Hoy' : `Hoy es ${moment().locale('es').format('DD/MM/YYYY')}`}</span>
                </div>
                {!is_today && <button className="btn btn-blue ms-3 justify-content-center align-self-center" onClick={() => this.onDay(moment())}>
                    <span className="white font-10 poppins align-self-center">Ir a hoy</span>
                </button>}
            </div>

            {/* SELECTOR DE FECHA */}
            <div className="ms-auto align-self-center" style={{ width: 150 }}>
                <DatePicker selected={day} highlightDates={[moment()]} customInput={<CustomDatePicker format="DD/MM/YYYY" hint="Fecha" />}
                    showYearDropdown scrollableYearDropdown yearDropdownItemNumber={15}
                    onChange={date => this.onDay(date)} className="white font-12" />
            </div>

            {/* BUSQUEDA */}
            <div className="ms-2 align-self-center" style={{ width: 260 }}>
                <div className={`black-input d-flex mt-2 ${this.state.search ? 'dirty' : ''}`}>
                    <i className="fas fa-search gray font-10 align-self-center ps-3" />
                    <input className="w-100 p-3 white font-10" type="text" placeholder="Habitación, huésped, PNR..."
                        value={this.state.search} onChange={(e) => this.setState({ search: e.target.value })} />
                    {this.state.search && <i className="fas fa-times gray font-10 align-self-center pe-3 pointer" onClick={() => this.setState({ search: '' })} />}
                </div>
            </div>

            {/* LEYENDA Y KPIS */}
            <div className="w-100 d-flex flex-wrap mt-3">
                {this.renderLegend()}
                <div className="ms-auto">{this.renderKpis(rows)}</div>
            </div>
        </div>
    }

    renderCell = (cell, index) => {
        const { piece, room_type, blocked, booking } = cell;
        const hit = this.matches_search(cell);

        let color_class = 'rack-cell-free white';
        let status_name = 'Disponible';

        if (booking) {
            const status = _.find(config.booking_status, s => s.id === booking.book.IdStatus);
            color_class = status ? status.color_class : 'w3-blue white';
            status_name = status ? status.name : '';
        } else if (blocked) {
            color_class = 'w3-red white';
            status_name = NO_DISPONIBLE.name;
        }

        const clickable = !!(booking || blocked); // con franja de color
        const guest = this.guest_name(booking);

        const title = booking
            ? `${piece.Label} · ${status_name} · ${guest} · ${moment(booking.check_in).format('DD/MM/YYYY')} al ${moment(booking.check_out).format('DD/MM/YYYY')}`
            : blocked
                ? `${piece.Label} · Fuera de servicio${blocked.reason ? ` · ${blocked.reason}` : ''}${blocked.until_label ? ` · hasta ${blocked.until_label}` : ''}`
                : `${piece.Label} · Disponible · clic para crear una reserva el ${moment(this.state.day).format('DD/MM/YYYY')}`;

        return <div key={piece.IdPiece || index} title={title}
            className={`rack-cell m-1 p-2 d-flex flex-column ${color_class} pointer ${hit === false ? 'rack-cell-dim' : ''} ${hit === true ? 'rack-cell-hit' : ''}`}
            onClick={() => this.onCellClick(cell)}>

            {clickable && <span className="rack-stripe" />}

            {/* NUMERO DE HABITACION */}
            <div className="d-flex w-100">
                <span className="font-14 poppins line1 align-self-center">{piece.Label}</span>
                {booking && blocked && <i className="ms-auto align-self-center font-10 fas fa-ban" title="Reservada y marcada fuera de servicio" />}
                <i className={`${booking && blocked ? 'ms-1' : 'ms-auto'} align-self-center font-10 ${booking ? 'fas fa-user' : blocked ? 'fas fa-ban' : 'far fa-circle'}`} />
            </div>

            {/* TIPO DE HABITACION */}
            <span className="font-8 poppins line1 rack-ellipsis mt-1" style={{ opacity: .75 }}>{room_type || 'Sin tipo'}</span>

            {/* HUESPED PRINCIPAL / MOTIVO DEL BLOQUEO / DISPONIBLE */}
            {booking && <div className="d-flex flex-column mt-auto">
                <span className="font-10 poppins rack-guest">{guest}</span>
                <span className="font-8 poppins line1 rack-ellipsis mt-1" style={{ opacity: .8 }}>{padWithZeros(booking.book.PNR)} · {status_name}</span>
            </div>}

            {!booking && blocked && <div className="d-flex flex-column mt-auto">
                <span className="font-10 poppins rack-guest">{blocked.reason || 'Fuera de servicio'}</span>
                <span className="font-8 poppins line1 rack-ellipsis mt-1" style={{ opacity: .8 }}>{blocked.until_label ? `Hasta ${blocked.until_label}` : 'Sin fecha estimada'}</span>
            </div>}

            {!booking && !blocked && <div className="d-flex flex-column mt-auto">
                <span className="green font-10 poppins line1">Disponible</span>
                <span className="gray-light font-8 poppins line1 mt-1">Clic para reservar</span>
            </div>}
        </div>
    }

    renderMatrix = (rows) => {
        if (!rows.length) return <div className="d-flex flex-column align-items-center py-5">
            <i className="fas fa-th gray font-40" />
            <span className="white font-12 poppins mt-3">No hay pisos configurados en esta propiedad</span>
            <Link to={`/floormap/${this.props.params.id}`} className="blue font-10 poppins underlined mt-2">Configurar mapa de pisos</Link>
        </div>;

        return <div className="rack-scroll mt-3">
            <div className="rack-grid">
                {rows.map((row, index) => <div className="rack-row" key={row.floor.IdFloor || index}>

                    {/* PISO */}
                    <div className="rack-floor d-flex flex-column justify-content-center px-2">
                        <span className="gray-light font-8 poppins line1">PISO</span>
                        <span className="white font-16 poppins line1">{row.floor.Label}</span>
                        <span className="gray-light font-8 poppins line1 mt-1">{row.cells.length} hab.</span>
                    </div>

                    {/* HABITACIONES */}
                    <div className="d-flex">
                        {row.cells.length > 0
                            ? row.cells.map((cell, i) => this.renderCell(cell, i))
                            : <div className="rack-cell rack-cell-free m-1 p-2 d-flex justify-content-center">
                                <span className="gray-light font-8 poppins align-self-center">Sin habitaciones</span>
                            </div>}
                    </div>
                </div>)}
            </div>
        </div>
    }

    renderCommon = () => {
        const rows = this.matrix();
        return <div>
            {this.renderHeader()}
            {this.renderTabs()}
            <Animated animationIn="fadeIn" animationInDuration={250} className="mt-4">
                <div className="bg-gray-2 p-3 rounded">
                    {this.renderControls(rows)}
                    {this.renderMatrix(rows)}
                </div>
            </Animated>
            <div style={{ height: 200 }} />
        </div>
    }

    render() {
        return (
            <Layout router={this.props.router} nbs="home" title="legendbeds" form={this.props.form} form_actions={this.props.form_actions}>
                <section>
                    {this.state.loading && <LineLoader />}
                    <div className="w3-container w3-hide-small" style={{ marginLeft: 100 }}>
                        <div style={{ height: 50 }} />
                        {this.renderCommon()}
                    </div>
                    <Menu {...this.state} {...this.props} />
                </section>
            </Layout>
        )
    }
}

export default Rack;
